import { render, staticRenderFns } from "./editIconsvg.vue?vue&type=template&id=6a571e5d"
import script from "./editIconsvg.vue?vue&type=script&lang=js"
export * from "./editIconsvg.vue?vue&type=script&lang=js"
import style0 from "./editIconsvg.vue?vue&type=style&index=0&id=6a571e5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports